module.exports = __webpack_public_path__ + "img/8.a7c909fa.jpg";